import React from 'react';
import { getUserData } from '../../api/userDataApi';
import Cookies from 'js-cookie'; // Для работы с куками

const UserNavRedirect = ({ activeForm, onCancel }) => {
  const handleRedirectMessenger = () => {
    try {
      // Редирект
      window.location.href = window.APP_CONFIG.MESSENGER_DOMAIN;
    } catch (e) {
      console.error('Ошибка при обработке SELLER_DOMAIN:', e);
    }
  };

  const handleRedirectCRM = () => {
    getUserData().then((res) => {
      const userData = res.data;

      if (userData.type_id && userData.type_id !== 2) {
        try {
          Cookies.set('current_organisation', userData.current_organisation, {
            expires: 7,
            domain: `.${window.APP_CONFIG?.TOKEN_DOMAIN}`,
            secure: true,
            sameSite: 'None',
          });

          const redirectUrl = new URL('https://business-test.multi-mir.ru/mono2/');
          redirectUrl.searchParams.set('module', 'kanban');

          window.location.href = redirectUrl.toString();
        } catch (e) {
          console.error('Ошибка при обработке SELLER_DOMAIN:', e);
        }
      } else {
        console.error('Ошибка при перехода');
      }
    });
  };

  return (
    <>
      <div
        onClick={onCancel}
        className={`overlay ${activeForm === 'redirect' ? 'show' : 'hide'}`}
      ></div>
      <div
        className={`auth-forms__form ${
          activeForm === 'redirect' ? 'show' : ''
        } auth-forms__form_login`}
      >
        <h2 className="auth-forms__title">Вход</h2>

        <div className="auth-forms__form-container-redirect">
          <button onClick={handleRedirectCRM} className="auth-forms__button">
            Личный кабинет
          </button>
          <button
            onClick={handleRedirectMessenger}
            className="auth-forms__button"
            style={{ background: 'blue' }}
          >
            Мессенджер
          </button>
        </div>
      </div>
    </>
  );
};

export default UserNavRedirect;
